/**
 * @generated SignedSource<<e59b98223b302bd5f16f7708dd637add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type styleArticleContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent" | "articleMoreOnThisListStyleArticle" | "globalCheckerContent" | "styleArticleAuthorBlockArticle">;
  readonly " $fragmentType": "styleArticleContent";
};
export type styleArticleContent$key = {
  readonly " $data"?: styleArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"styleArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "styleArticleContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleMoreOnThisListStyleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "styleArticleAuthorBlockArticle"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "ef02c366a2c03c9463c9945a42591de5";

export default node;
